import { motion, useInView, useAnimation } from "framer-motion";
import { useEffect, useRef } from "react";
import data from "../data.json";


const Skills = ({ refSkills }) => {
    const ref = useRef(null);
    const isInView = useInView(ref);
    const mainControlls = useAnimation();
    const mainControlls1 = useAnimation();
    const mainControlls2 = useAnimation();
    const mainControlls3 = useAnimation();
    const mainControlls4 = useAnimation();
    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);
    const refs = { ref1, ref2, ref3, ref4 };
    const isInView1 = useInView(ref1);
    const isInView2 = useInView(ref2);
    const isInView3 = useInView(ref3);
    const isInView4 = useInView(ref4);
    const animations = { mainControlls1, mainControlls2, mainControlls3, mainControlls4 };

    useEffect(() => {
        if (isInView) {
            mainControlls.start("visible")
        }
        else {
            mainControlls.start("hidden")
        }


    }, [isInView,mainControlls]);

    useEffect(() => {
        if (isInView1) {
            mainControlls1.start("visible")
        }
        else {
            mainControlls1.start("hidden")
        }


    }, [isInView1,mainControlls1])

    useEffect(() => {
        if (isInView2) {
            mainControlls2.start("visible")
        }
        else {
            mainControlls2.start("hidden")
        }


    }, [isInView2,mainControlls2])
    useEffect(() => {
        if (isInView3) {
            mainControlls3.start("visible")
        }
        else {
            mainControlls3.start("hidden")
        }


    }, [isInView3,mainControlls3])
    useEffect(() => {
        if (isInView4) {
            mainControlls4.start("visible")
        }
        else {
            mainControlls4.start("hidden")
        }


    }, [isInView4,mainControlls4])

    return (
        <div className="item" ref={refSkills} >
            <div ref={ref}>
                <motion.div className="projects-motion" variants={{
                    hidden: { opacity: 0, x: -150 },
                    visible: { opacity: 1, x: 0 }
                }}
                    initial="hidden"
                    animate={mainControlls}
                    transition={{ duration: 0.5 }}
                    whileHover={{ scale: 1 }}
                >
                    <div className="item-title" style={{ color: "white" }}>Skills</div>

                    <div className="skills-item">
                        {data.skills.map((e, i) => {
                            if (i % 2 === 0) {
                                return (
                                    <motion.div
                                        variants={{
                                            hidden: { opacity: 0, x: -150 },
                                            visible: { opacity: 1, x: 0 }
                                        }}
                                        initial="hidden"
                                        animate={animations["mainControlls" + (i + 1)]}
                                        transition={{ duration: 0.5 }}

                                        style={{ display: "flex", flexDirection: "column" }} ref={refs["ref" + (i + 1)]}>
                                        <h3>{e.title}</h3>
                                        <div style={{ display: "flex", flexWrap: "wrap" }}>
                                            {e.skills.map((h, idx) => {

                                                return (
                                                    <div className="skill-div"
                                                    >
                                                        <motion.img className="skill-img" src={"./pictures/" + h + ".png"} whileHover={{ scale: 1.2 }} whileTap={{ y: -100, rotateZ: 180 }}></motion.img>
                                                        <h4>{h}</h4>
                                                    </div>


                                                )

                                            })}
                                        </div>
                                    </motion.div>
                                )
                            }
                            else {
                                return (
                                    <motion.div
                                        variants={{
                                            hidden: { opacity: 0, x: 150 },
                                            visible: { opacity: 1, x: 0 }
                                        }}
                                        initial="hidden"
                                        animate={animations["mainControlls" + (i + 1)]}
                                        transition={{ duration: 0.5 }}
                                        style={{ display: "flex", flexDirection: "column" }} ref={refs["ref" + (i + 1)]}>
                                        <h3 style={{ display: "flex", justifyContent: "flex-end" }}>{e.title}</h3>
                                        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "flex-end" }}>
                                            {e.skills.map((h) => {

                                                return (

                                                    <div className="skill-div"

                                                    >
                                                        <motion.img src={"./pictures/" + h + ".png"} whileHover={{ scale: 1.2 }} whileTap={{ y: -100, rotateZ: 180 }} className="skill-img"></motion.img>
                                                        <h4 >{h}</h4>
                                                    </div>)

                                            })}
                                        </div>
                                    </motion.div>
                                )

                            }
                        })}
                    </div>
                </motion.div>
            </div >

        </div >
    )
}

export default Skills;